// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
//import axios from 'axios';
//import {  getCartId } from '../../utils/auth';

 
export const fetchAppSettings = createAsyncThunk('settings/fetchAppSettings', async () => {
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/settings',{
         headers: {
             'Content-Type':'application/json',
           }, 
           method: 'GET'
 
    }); 
     return response.json(); 
});
 
// Slice
const settingsSlice = createSlice({
    name: 'settings',
    initialState: { 
        loading: false,
        states: [],
        countries: [], 
        categories: [],
        hotDeals: [],
        error: '' 

    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            
            .addCase(fetchAppSettings.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(fetchAppSettings.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    state.states = action.payload['states']
                    state.countries = action.payload['countries'] 
                    state.categories = action.payload.categories;
                    state.hotDeals = action.payload.hot_deals;
                    state.error = ''; 
                }
                else{
                    state.loading = false;
                    state.error = ''; 
                }
            })
            .addCase(fetchAppSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = '';
            })

             
            
    }
});

//export const { logout } = authSlice.actions;
export default settingsSlice.reducer;
